
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/asset-pro",
      function () {
        return require("private-next-pages/products/asset-pro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/asset-pro"])
      });
    }
  